import { render, staticRenderFns } from "./SyncInventory.vue?vue&type=template&id=afa64a74&"
import script from "./SyncInventory.vue?vue&type=script&lang=js&"
export * from "./SyncInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports